import React, { useState } from 'react'
import { Box, Backdrop, IconButton, LinearProgress } from '@mui/material'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import Module from './Module'
import { getModuleTheme } from '../../../common/constants/themeConstants'

export default function ModulesPreview({
  open,
  onClose,
  modules,
  isAttemptPreview,
  completedModules,
  theme,
  onNextModule = () => {}
}) {
  const [currentIndex, setCurrentIndex] = useState(0)
  const filteredModules = modules.filter(module => module.type)

  if (!open || filteredModules.length === 0) {
    return null
  }

  const handleNext = e => {
    e.stopPropagation()
    if (currentIndex < filteredModules.length - 1) {
      setCurrentIndex(prevIndex => prevIndex + 1)
    } else if (isAttemptPreview) {
      onNextModule()
      setCurrentIndex(0)
    }
  }

  const handlePrevious = e => {
    e.stopPropagation()
    if (currentIndex > 0) {
      setCurrentIndex(prevIndex => prevIndex - 1)
    }
  }

  const progress = ((currentIndex + 1) / filteredModules.length) * 100

  return (
    <Backdrop
      open={open}
      onClick={() => {
        setCurrentIndex(0)
        onClose()
      }}
      sx={styles.backdrop}
    >
      <Box onClick={e => e.stopPropagation()} sx={styles.modulesContainer}>
        {filteredModules.map((module, index) => {
          const distance = index - currentIndex
          const moduleIndex = (module.sequenceNumber || 1) - 1
          const moduleTheme = getModuleTheme(theme, moduleIndex)
          return (
            <Module
              completedModules={completedModules}
              key={index}
              step={module}
              theme={moduleTheme}
              isActive={index === currentIndex}
              isPreview={true}
              name={`preview_${index}`}
              style={{
                ...((distance > 3 || distance < -3) && { display: 'none' }),
                opacity: distance == 3 || distance == -3 ? 0.5 : 1,
                boxShadow: ' -5px 5px 10px 0px rgba(0, 0, 0, 0.2)',

                transform: `translateX(${-distance * 25}px)
                translateY(${distance * 4}px)
                scale(${index === currentIndex ? 1 : 1 - 0.03 * Math.abs(distance)})`,
                zIndex: filteredModules.length - Math.abs(distance),
                transition: 'transform 0.3s ease, z-index 0.3s ease'
              }}
            />
          )
        })}
      </Box>

      <IconButton onClick={handlePrevious} disabled={currentIndex === 0} sx={styles.navButton} className='prev-button'>
        <ArrowBackIosNewIcon />
      </IconButton>

      <IconButton
        onClick={handleNext}
        disabled={isAttemptPreview ? false : currentIndex === filteredModules.length - 1}
        sx={styles.navButton}
        className='next-button'
      >
        <ArrowForwardIosIcon />
      </IconButton>

      <Box sx={styles.progressContainer}>
        <LinearProgress variant='determinate' value={progress} sx={styles.progressBar} />
      </Box>
    </Backdrop>
  )
}

const styles = {
  backdrop: {
    height: '100vh',
    zIndex: 1300,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    backdropFilter: 'blur(5px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '20px'
  },
  modulesContainer: {
    position: 'relative',
    height: 'calc(100vh - 240px)',
    minHeight: '450px',
    width: '100%',
    maxWidth: '1000px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'visible'
  },
  navButton: {
    position: 'fixed',
    width: '48px',
    height: '48px',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.3)'
    },
    '&.Mui-disabled': {
      opacity: 0.3
    },
    '&.prev-button': {
      left: '5%',
      top: '50%',
      transform: 'translateY(-50%)'
    },
    '&.next-button': {
      right: '5%',
      top: '50%',
      transform: 'translateY(-50%)'
    },
    zIndex: 1400
  },
  progressContainer: {
    width: '80%',
    maxWidth: '600px'
  },
  progressBar: {
    height: '8px',
    borderRadius: '4px',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    '& .MuiLinearProgress-bar': {
      backgroundColor: '#6123FF'
    }
  }
}
